import Modal from "@atoms/Modal/Modal";
import SelectBox from "@atoms/SelectBox/SelectBox";
import useModal from "@hooks/useModal";
import IconFilterClassification from "@images/pressList/icon-filter-classification-white.svg";
import IconFilterStatus from "@images/pressList/icon-filter-status-white.svg";
import PressListCheckboxFilter from "@PressListContainer/components/PressListTableFilter/components/PressListCheckboxFilter/PressListCheckboxFilter";
import { usePatentListFilterState } from "@stores/patentList";

import PatentPrimaryCategoryFilter from "./components/PatentPrimaryCategoryFilter/PatentPrimaryCategoryFilter";
import PatentSearch from "./components/PatentSearch/PatentSearch";
import PatentSearchResult from "./components/PatentSearchResult/PatentSearchResult";
import StatusFilter from "./components/StatusFilter/StatusFilter";
import * as S from "./PatentTableFilter.style";

const LIMIT_NUMBER_LIST = [20, 40, 60, 80, 100];

const PatentTableFilter = () => {
  const [patentListFilter, setPatentListFilter] = usePatentListFilterState();

  const { pageLimit, status, primaryCategory, drugProfileExtractable } =
    patentListFilter;

  const {
    isModal: isPrimaryCategoryFilterModalOpen,
    openModal: openPrimaryCategoryFilterModal,
    closeModal: closePrimaryCategoryFilterModal,
  } = useModal();
  const {
    isModal: isStatusFilterModalOpen,
    openModal: openStatusFilterModal,
    closeModal: closeStatusFilterModal,
  } = useModal();

  const selectedPrimaryCategoryNumber = primaryCategory.length;
  const selectedStatusNumber = status.length;

  const handleSelectLimitNumber = (value: string) => {
    setPatentListFilter({
      ...patentListFilter,
      pageLimit: Number(value),
      page: 1,
    });
  };

  // 페이지 유지
  const handleToggleExtractable = (checked: boolean) => {
    setPatentListFilter({
      ...patentListFilter,
      drugProfileExtractable: checked,
    });
  };

  return (
    <>
      <S.PatentListTableFilterWrapper>
        <PatentSearch />
        <S.TableFilterColumn>
          <S.FilterButton
            buttonWidth={14.8}
            buttonSize="xSmall"
            buttonStyle="solidSky"
            onClick={openPrimaryCategoryFilterModal}
          >
            <img src={IconFilterClassification} alt="primary category filter" />
            Primary Category Filter
            {selectedPrimaryCategoryNumber > 0 &&
              `(${selectedPrimaryCategoryNumber})`}
          </S.FilterButton>
          <S.FilterButton
            buttonSize="xSmall"
            buttonStyle="solidBlueGreen"
            onClick={openStatusFilterModal}
          >
            <img src={IconFilterStatus} alt="status filter" />
            Status Filter
            {selectedStatusNumber > 0 && `(${selectedStatusNumber})`}
          </S.FilterButton>
          <PressListCheckboxFilter
            filterText="Extractable"
            isChecked={drugProfileExtractable ?? false}
            onClick={() =>
              handleToggleExtractable(!(drugProfileExtractable ?? false))
            }
          />
          <SelectBox
            optionList={LIMIT_NUMBER_LIST}
            defaultText=" accounts per page"
            selectValue={pageLimit}
            onChangeOption={handleSelectLimitNumber}
          />
          {isPrimaryCategoryFilterModalOpen && (
            <Modal closeModal={closePrimaryCategoryFilterModal}>
              <PatentPrimaryCategoryFilter
                closeModal={closePrimaryCategoryFilterModal}
              />
            </Modal>
          )}
          {isStatusFilterModalOpen && (
            <Modal closeModal={closeStatusFilterModal}>
              <StatusFilter closeModal={closeStatusFilterModal} />
            </Modal>
          )}
        </S.TableFilterColumn>
      </S.PatentListTableFilterWrapper>
      <PatentSearchResult />
    </>
  );
};

export default PatentTableFilter;
